import { Component } from 'solid-js';
import { Doughnut } from 'solid-chartjs';
import { Chart, Title, Tooltip, Legend, ArcElement } from 'chart.js';

// Register Chart.js components
Chart.register(Title, Tooltip, Legend, ArcElement);

interface DoughnutChartProps {
  labels: string[];
  datasets: {
    label: string;
    data: number[];
    backgroundColor?: string | string[];
    borderColor?: string | string[];
  }[];
  title?: string;
  height?: number;
  colors?: string[];
}

/**
 * DoughnutChart Component
 * Wrapper around Chart.js Doughnut chart for SolidJS
 */
const DoughnutChart: Component<DoughnutChartProps> = (props) => {
  const defaultColors = [
    'rgba(99, 102, 241, 0.8)',
    'rgba(16, 185, 129, 0.8)',
    'rgba(251, 191, 36, 0.8)',
    'rgba(239, 68, 68, 0.8)',
    'rgba(139, 92, 246, 0.8)',
    'rgba(236, 72, 153, 0.8)',
    'rgba(59, 130, 246, 0.8)',
    'rgba(34, 197, 94, 0.8)',
    'rgba(168, 85, 247, 0.8)',
    'rgba(249, 115, 22, 0.8)',
  ];

  const colors = props.colors || defaultColors;

  const chartData = () => ({
    labels: props.labels,
    datasets: props.datasets.map((dataset) => ({
      ...dataset,
      backgroundColor: dataset.backgroundColor || colors,
      borderColor:
        dataset.borderColor ||
        colors.map((color) => color.replace(/0\.8/, '1')),
      borderWidth: 2,
    })),
  });

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: !!props.title,
        text: props.title,
        color: 'rgb(156, 163, 175)',
        font: {
          size: 14,
          weight: 'normal' as const,
        },
      },
      tooltip: {
        backgroundColor: 'rgba(17, 24, 39, 0.9)',
        titleColor: 'rgb(243, 244, 246)',
        bodyColor: 'rgb(209, 213, 219)',
        borderColor: 'rgb(75, 85, 99)',
        borderWidth: 1,
        padding: 12,
        displayColors: true,
        boxWidth: 10,
        boxHeight: 10,
      },
    },
  };

  return (
    <div style={{ height: `${props.height || 250}px` }}>
      <Doughnut data={chartData()} options={chartOptions} />
    </div>
  );
};

export default DoughnutChart;
